import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";

import "./Marketing.css"
import ChartCheckbox from "../Dashboard/Tools/ChartCheckbox";
import DualSquareSelector from "../../Square/SquareDiv";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useSelector } from 'react-redux';

function MarkrtingUserCreate() {
  const selectorRef = useRef();
  const selectorRef1 = useRef();

  const handleResetClick = () => {
    if (selectorRef.current) {
      selectorRef.current.resetSelection();
    }
  };
  const handleResetClick1 = () => {
    if (selectorRef.current) {
      selectorRef1.current.resetSelection();
    }
  };
  const [affiliateInput, setAffiliateInput] = useState("");
  const [selectedCommissionGroupItems, setSelectedCommissionGroupItems] = useState([]);
  const [selectedAffiliateGroupItems, setSelectedAffiliateGroupItems] = useState([]);
  const [ischeckD, setisCheckD] = useState(false)
  const [ischeckP, setisCheckP] = useState(false)
  const [ischeckPo, setisCheckPo] = useState(false)
  const [ischeckAP, setisCheckAP] = useState(false)
  const [ischeckM, setisCheckM] = useState(false)
  const [ltLang, setLtLang] = useState([])
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([])
  const [compaignValidation, setCompaignValidation] = useState({
    name: null,
    affiliates: null,
    language: null,
    affiliategroups: null,
    commissiongroups: null,
  })
  const [CreateCompaignFilter, setCreateCompaignFilter] = useState({
    name: "",
    language: 1,
    link: "",
    onlydirectlinks: 0,
    phpcode: 0,
    postbackapi: 0,
    apkdownload: 0,
    mainpage: 0,
    commissiongroups: [],
    affiliategroups: [],
    affiliates: []
  })
  const [loading, setLoading] = useState(false)
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  // Callback function to handle changes in checkbox state
  const handleDCheckboxChange = (newCheckedState) => {
    setisCheckD(newCheckedState);
    setCreateCompaignFilter({ ...CreateCompaignFilter, onlydirectlinks: newCheckedState ? 1 : 0 });
  };

  const handlePCheckboxChange = (newCheckedState) => {
    setisCheckP(newCheckedState)
    setCreateCompaignFilter({ ...CreateCompaignFilter, phpcode: newCheckedState ? 1 : 0 });
  };
  const handlePOCheckboxChange = (newCheckedState) => {
    setisCheckPo(newCheckedState)
    setCreateCompaignFilter({ ...CreateCompaignFilter, postbackapi: newCheckedState ? 1 : 0 });
  };
  const handleAPCheckboxChange = (newCheckedState) => {
    setisCheckAP(newCheckedState)
    setCreateCompaignFilter({ ...CreateCompaignFilter, apkdownload: newCheckedState ? 1 : 0 });
  };
  const handleMCheckboxChange = (newCheckedState) => {
    setisCheckM(newCheckedState)
    setCreateCompaignFilter({ ...CreateCompaignFilter, mainpage: newCheckedState ? 1 : 0 });
  };

  const handleSelectionCommissionGroupChange = (selectedRows) => {
    setSelectedCommissionGroupItems(selectedRows);
  };
  const handleSelectionAffiliateGroupChange = (selectedRows) => {
    setSelectedAffiliateGroupItems(selectedRows);
  };
  const CreateCompaign = async () => {
    var mCampaignAffObj = Object.assign({}, CreateCompaignFilter)

    if (selectedCommissionGroupItems.length > 0) {
      mCampaignAffObj.commissiongroups = selectedCommissionGroupItems.map(d => parseInt(d.value))
    }
    if (selectedAffiliateGroupItems.length > 0) {
      mCampaignAffObj.affiliategroups = selectedAffiliateGroupItems.map(d => parseInt(d.value))
    }
    var initValidation = {
      name: null,
      affiliates: null,
      language: null,
      affiliategroups: null,
      commissiongroups: null,
    }
    var errored = false
    if (mCampaignAffObj.name === "") {
      initValidation.name = "Name is required"
      errored = true
    }
    // if (affiliateInput === "") {
    //   initValidation.affiliates = "affiliates is required"
    //   errored = true
    // }
    if (mCampaignAffObj.affiliategroups.length === 0) {
      initValidation.affiliategroups = "affiliate group is required"
      errored = true
    }
    if (mCampaignAffObj.commissiongroups.length === 0) {
      initValidation.commissiongroups = "commision group is required"
      errored = true
    }
    
    setCompaignValidation(initValidation)
    if (errored) return;
    var af = affiliateInput.split(',')
    if (af.length > 0)
      af.forEach(id => { id = parseInt(id) })
    if(af != "")
      mCampaignAffObj.affiliates = af.filter(item => typeof parseInt(item) === 'number' && !isNaN(item));
    setLoading(true)
    const response = await axios.post(window.__CFG.API + "marketing/CreateCampaign", mCampaignAffObj, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error == null) {
      setLoading(false)
      toast.success("Updated Sucessufully", {
        duration: 4000
      });
      setSelectedCommissionGroupItems([])
      setSelectedAffiliateGroupItems([])
      setAffiliateInput("")
      setCreateCompaignFilter({
        name: "",
        language: 1,
        link: "",
        onlydirectlinks: 0,
        phpcode: 0,
        postbackapi: 0,
        apkdownload: 0,
        mainpage: 0,
        commissiongroups: [],
        affiliategroups: [],
        affiliates: []
      })
      handleResetClick()
      handleResetClick1()
      setisCheckD(false)
      setisCheckP(false);
      setisCheckPo(false);
      setisCheckAP(false);
      setisCheckM(false);
    }
    else {
      toast.error(response.data.Error, {
        duration: 4000
      });
    }
  }
  const getListLanguages = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtLang(response.data.Result)
    }
  }
  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "mkt_create_campaign")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  useEffect(() => { getListLanguages(); getListAffliateGrp(); getListCommissionGrp(); }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]

  return (
    <>
      <Container>
        <Row>
          <Col>

            <h4 className="text-start mt-5">Create new Campaign</h4>

            {/* <h5 className="text-start mt-5" style={{ fontSize: "15px" }}>
            Currency: USD
          </h5> */}
            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-1 me-auto w-75 form-add-aff">

              <Col lg={4} md={4} sm={5}>
                <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                  <label>Campaign name</label>
                </div>
                <Form.Control disabled={!affliatePermission} value={CreateCompaignFilter.name} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} onChange={(e) => { setCreateCompaignFilter({ ...CreateCompaignFilter, name: e.target.value }); }} />
                {
                  compaignValidation.name !== null ? (
                    <div class="invalid-feedback loginForm">
                      {compaignValidation.name}
                    </div>
                  ) : (
                    <></>
                  )
                }
              </Col>
              <Col lg={4} md={4} sm={4}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>Language</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }} >
                    <Select isDisabled={!affliatePermission} options={ltLang.filter(d => {
                      return d.value != ""
                    })} onChange={(e) => { setCreateCompaignFilter({ ...CreateCompaignFilter, language: e.value }); }} />

                  </div>
                  {
                    compaignValidation.name !== null ? (
                      <div class="invalid-feedback loginForm">
                        {compaignValidation.language}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </div>
              </Col>
            </Row>
            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-1 me-auto w-75 form-add-aff">
              <Col lg={4} md={4} sm={4}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>Currency</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                    <Select isDisabled={!affliatePermission} options={optionsCurrency} />
                  </div>

                </div>
              </Col>
              <Col lg={4} md={4} sm={5}>
                <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                  <label>Link</label>
                </div>
                <Form.Control disabled={!affliatePermission} value={CreateCompaignFilter.link} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} onChange={(e) => { setCreateCompaignFilter({ ...CreateCompaignFilter, link: e.target.value }); }} />
              </Col>

            </Row>
            <Row className="justify-content-between  mt-4 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="d-flex align-items-center text-start ">
                  <div>
                    <ChartCheckbox label="" disabled={!affliatePermission} initialChecked={ischeckD} size="14px" onChange={handleDCheckboxChange} />
                  </div>
                  <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 cursor-pointer"
                    style={{ fontSize: "13px", marginLeft: 3 }}
                  >
                    Only direct link
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-1 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="d-flex align-items-center text-start ">
                  <div>
                    <ChartCheckbox label="" disabled={!affliatePermission} initialChecked={ischeckP} size="14px" onChange={handlePCheckboxChange} />
                  </div>                <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 cursor-pointer"
                    style={{ fontSize: "13px", marginLeft: 3 }}
                  >
                    PHP code
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-1 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="d-flex align-items-center text-start ">
                  <div>
                    <ChartCheckbox disabled={!affliatePermission} label="" initialChecked={ischeckPo} size="14px" onChange={handlePOCheckboxChange} />
                  </div>                <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 cursor-pointer"
                    style={{ fontSize: "13px", marginLeft: 3 }}
                  >
                    PostbackAPI
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-1 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="d-flex align-items-center text-start ">
                  <div>
                    <ChartCheckbox disabled={!affliatePermission} label="" initialChecked={ischeckAP} size="14px" onChange={handleAPCheckboxChange} />
                  </div>                <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 cursor-pointer"
                    style={{ fontSize: "13px", marginLeft: 3 }}
                  >
                    For APK download
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-1 me-auto w-100">
              <Col lg={6} md={4} sm={4}>
                <div className="d-flex align-items-center text-start ">
                  <div>
                    <ChartCheckbox disabled={!affliatePermission} label="" initialChecked={ischeckM} size="14px" onChange={handleMCheckboxChange} />
                  </div>
                  <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 cursor-pointer"
                    style={{ fontSize: "13px", marginLeft: 3 }}
                  >
                    For main page
                  </label>
                </div>
              </Col>
            </Row>


            <Row className="d-flex justify-content-between align-items-center mt-5">
              <Col className="text-start ">
                <Form.Group>
                  <DualSquareSelector ref={selectorRef} items={affliatePermission ? ltComGrp.filter(d => {
                    return d.value != ""
                  }) : []} onSelectedItemsChange={handleSelectionCommissionGroupChange} labelSelect="commission groups" />
                </Form.Group>
                {
                  compaignValidation.commissiongroups !== null ? (
                    <div class="invalid-feedback loginForm">
                      {compaignValidation.commissiongroups}
                    </div>
                  ) : (
                    <></>
                  )
                }
              </Col>
            </Row>

            <Row className="d-flex justify-content-between align-items-center mt-5">
              <Col className="text-start ">
                <Form.Group>
                  <DualSquareSelector ref={selectorRef1} items={affliatePermission ? ltAffGrp.filter(d => {
                    return d.value != ""
                  }) : []} onSelectedItemsChange={handleSelectionAffiliateGroupChange} labelSelect="affiliate groups" />
                  {
                    compaignValidation.affiliategroups !== null ? (
                      <div class="invalid-feedback loginForm">
                        {compaignValidation.affiliategroups}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </Form.Group>
              </Col>
            </Row>
            <Row className="justify-content-start mt-4 me-auto w-100">
              <Col lg={3} md={4} sm={4}>
                <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                  <label>Only for affiliates</label>
                </div>
                <Form.Control disabled={!affliatePermission} value={affiliateInput} type="text" style={{ width: "100%", padding: 6, fontSize : 13 }} onChange={(e) => { setAffiliateInput(e.target.value) }} placeholder="Affiliates IDs separated by commas" />
                {
                  compaignValidation.affiliates !== null ? (
                    <div class="invalid-feedback loginForm">
                      {compaignValidation.affiliates}
                    </div>
                  ) : (
                    <></>
                  )
                }
              </Col>
            </Row>

            <Row className="justify-content-start mt-2 me-auto w-75 mb-5">
              <Col lg={4} md={4} sm={5} className=" pt-3  md-se-btn">
                <Button disabled={!affliatePermission || loading} onClick={CreateCompaign} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  {loading ? (<> <Spinner size="sm"></Spinner></>) : (<>
                    Create
                  </>)}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default MarkrtingUserCreate;
